import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : BACKEND_URL.endsWith('/') ? `${BACKEND_URL}api` : `${BACKEND_URL}/api`;

const getHeaders = (currentUser) => {
  let user = currentUser;
  if (!user) {
    try {
      user = JSON.parse(sessionStorage.getItem('pharmacy_user') || localStorage.getItem('pharmacy_user'));
    } catch {}
  }
  return {
    'Content-Type': 'application/json',
    ...(user?.id ? { 'X-User-Id': user.id } : {}),
    ...(user?.session_token ? { 'X-Session-Token': user.session_token } : {})
  };
};

export const bankService = {
  // Bank Accounts
  getAccounts: async (currentUser, params = {}) => {
    const response = await axios.get(`${API}/bank-accounts`, {
      headers: getHeaders(currentUser),
      params
    });
    return response.data;
  },

  createAccount: async (currentUser, accountData) => {
    const response = await axios.post(`${API}/bank-accounts`, accountData, {
      headers: getHeaders(currentUser)
    });
    return response.data;
  },

  updateAccount: async (currentUser, id, accountData) => {
    const response = await axios.put(`${API}/bank-accounts/${id}`, accountData, {
      headers: getHeaders(currentUser)
    });
    return response.data;
  },

  deleteAccount: async (currentUser, id) => {
    const response = await axios.delete(`${API}/bank-accounts/${id}`, {
      headers: getHeaders(currentUser)
    });
    return response.data;
  },

  // Bank Transactions
  getTransactions: async (currentUser, params = {}) => {
    const response = await axios.get(`${API}/bank-transactions`, {
      headers: getHeaders(currentUser),
      params
    });
    return response.data;
  },

  createTransaction: async (currentUser, transactionData) => {
    const response = await axios.post(`${API}/bank-transactions`, transactionData, {
      headers: getHeaders(currentUser)
    });
    return response.data;
  },

  updateTransaction: async (currentUser, id, transactionData) => {
    const response = await axios.put(`${API}/bank-transactions/${id}`, transactionData, {
      headers: getHeaders(currentUser)
    });
    return response.data;
  },

  deleteTransaction: async (currentUser, id) => {
    const response = await axios.delete(`${API}/bank-transactions/${id}`, {
      headers: getHeaders(currentUser)
    });
    return response.data;
  },

  // Statistics
  getStats: async (currentUser, params = {}) => {
    const response = await axios.get(`${API}/bank-transactions/stats`, {
      headers: getHeaders(currentUser),
      params
    });
    return response.data;
  }
};
